import { CSSProperties } from 'react';

interface ThemedMapTokens {
    colorBgElevated: string;
    colorBorder: string;
    colorBorderSecondary: string;
    colorFillTertiary: string;
    colorLink: string;
    colorLinkHover: string;
    colorPrimary: string;
    colorText: string;
    colorTextSecondary: string;
}

type ThemedMapStyle = CSSProperties & {
    '--cc-map-control-bg': string;
    '--cc-map-control-border': string;
    '--cc-map-control-border-secondary': string;
    '--cc-map-control-focus': string;
    '--cc-map-control-hover-bg': string;
    '--cc-map-control-link': string;
    '--cc-map-control-link-hover': string;
    '--cc-map-control-text': string;
    '--cc-map-control-text-secondary': string;
};

export const createThemedMapStyle = (token: ThemedMapTokens, style: CSSProperties): ThemedMapStyle => ({
    '--cc-map-control-bg': token.colorBgElevated,
    '--cc-map-control-border': token.colorBorder,
    '--cc-map-control-border-secondary': token.colorBorderSecondary,
    '--cc-map-control-focus': token.colorPrimary,
    '--cc-map-control-hover-bg': token.colorFillTertiary,
    '--cc-map-control-link': token.colorLink,
    '--cc-map-control-link-hover': token.colorLinkHover,
    '--cc-map-control-text': token.colorText,
    '--cc-map-control-text-secondary': token.colorTextSecondary,
    ...style,
});
